var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12.07,
    viewBox: "0 0 12 12.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#83A9C7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.765.181a.284.284 0 0 0-.53 0l-.253.646a.285.285 0 0 1-.16.161l-.642.255a.287.287 0 0 0 0 .532l.642.255c.073.029.131.087.16.16l.253.646a.284.284 0 0 0 .53 0l.253-.645a.285.285 0 0 1 .16-.161l.642-.255a.287.287 0 0 0 0-.532l-.642-.255a.285.285 0 0 1-.16-.161L10.765.18ZM8.284 3.212a.305.305 0 0 0-.568 0l-.1.253a.306.306 0 0 1-.171.173l-.252.1a.308.308 0 0 0 0 .571l.252.1a.306.306 0 0 1 .172.173l.099.253c.102.26.466.26.568 0l.1-.253a.306.306 0 0 1 .171-.173l.252-.1a.308.308 0 0 0 0-.571l-.252-.1a.306.306 0 0 1-.172-.173l-.099-.253Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12.07c3.314 0 6-2.702 6-6.035 0-.28-.416-.325-.56-.086A3.893 3.893 0 0 1 8.1 7.846c-2.154 0-3.9-1.757-3.9-3.923 0-1.425.756-2.673 1.886-3.36C6.324.419 6.278 0 6 0 2.686 0 0 2.702 0 6.035s2.686 6.035 6 6.035Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.cce72a481457f4772ab4069acde9de13.svg";
export { ForwardRef as ReactComponent };